React = require 'react'
SchedulingMixin = require 'lib/scheduling-mixin'
mixin = require 'lib/mixin'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_search')

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @scheduler = new SchedulingMixin()

    @state = {
      searchHasFocus: false
      query: ""
    }

  componentWillReceiveProps: (nextProps) ->
    if nextProps.clearValue
      @refs['search-input'].value = ""
      @setState query: ""

  componentWillMount: ->
    @debouncedOnQueryChange = @proportionalDebounce(@onQueryChange)

  componentWillUnmount: ->
    # cancels the debounced change listener
    @scheduler.cancelScheduled()

  proportionalDebounce: (fn) ->
    @scheduler.dynamicDebounce fn, (query, noPenalty = false) ->
      baseDelayMs = 300

      if noPenalty
        return baseDelayMs

      # Increase debounce time for short queries and large collections
      penalty = 1
      if query.length < 3
        penalty++
      if query.length < 2
        penalty++
      if @props.searchCount > 100
        penalty++
      if @props.searchCount > 500
        penalty++

      baseDelayMs * penalty

  render: t.renderable ->
    t.div '.enterprise-search-wrapper', =>
      t.input '.enterprise-search-input',
        class: t.classify('js-autofocus': @props.autofocus != false)
        type: 'text'
        ref: 'search-input'
        placeholder: @props.placeholder
        onFocus: (e) => @setState searchHasFocus: true
        onBlur: (e) => @setState searchHasFocus: false
        onChange: (e) =>
          query = e.target.value.trim()
          @setState { query }
          if @props.debounce
            @debouncedOnQueryChange(query, !query)
          else
            @onQueryChange(query)
        onKeyPress: (e) =>
          if e.key == 'Enter'
            if @props.debounce
              @debouncedOnQueryChange(@state.query, true)
            else
              @onQueryChange(@state.query)


      if @state.query != ""
        t.span '.enterprise-search-close-icon.icon-lg.icon-close.light',
          class: t.classify('active': @state.searchHasFocus)
          onClick: @onClearClick

  onQueryChange: (query) => @props.onChange(query)

  onClearClick: =>
    @refs['search-input'].value = ""
    @setState query: ""
    @props.onChange("")



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/search-component.coffee